import { render, staticRenderFns } from "./watch-doc.vue?vue&type=template&id=32508193&scoped=true&"
import script from "./watch-doc.vue?vue&type=script&lang=js&"
export * from "./watch-doc.vue?vue&type=script&lang=js&"
import style0 from "./watch-doc.vue?vue&type=style&index=0&id=32508193&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32508193",
  null
  
)

export default component.exports